
// import lib
import validHelper from '../lib/validHelper';
import isEmpty from '../lib/isEmpty';

export const registerValid = (reqBody) => {
    let validDoc = {
        pinNumber: { type: 'string', required: true },
        email: { type: 'string', required: true, regex: 'email' },
        userName: { type: 'string', required: true, min: 3, max: 16 },
        password: { type: 'string', required: true, min: 6, max: 16 },
        phone: { type: 'number', required: true, length: 10 },
        referralCode: { type: 'string', required: true },
        side: { type: 'string', required: true, enum: ['left', 'right'] }
    };
    return validHelper(validDoc, reqBody)
}

export const loginValid = (reqBody) => {
    let validDoc = {
        userId: { type: 'string', required: true },
        password: { type: 'string', required: true },
        // rememberMe: { type: 'boolean', required: true }
    };
    return validHelper(validDoc, reqBody)
}

export const contactValid = (reqBody) => {
    let validDoc = {
        name: { type: 'string', required: true, min: 3, max: 16 },
        email: { type: 'string', required: true, regex: 'email' },
        phone: { type: 'number', required: true, length: 10 },
        subject: { type: 'string', required: true, min: 3, max: 16 },
        message: { type: 'string', required: true, min: 3, max: 250 },
    }
    return validHelper(validDoc, reqBody)
}